
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("blySf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f7d661c9737b7636$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $f7d661c9737b7636$export$2e2bcd8739ae039 = {
    'identity.account-menu.account-details.view-profile-link': 'Profiel bekijken',
    'identity.account-menu.account-menu-content.log-out-button': 'Uitloggen',
    'identity.account-menu.account-menu-content.switch-account-button': 'Account wisselen',
    'identity.account-menu.account-menu-details.managed-account': 'Dit account wordt beheerd door <b>{managedBy}</b>.',
    'identity.account-menu.account-menu-popup.skeleton.tooltip': 'Account'
};

});


//# sourceMappingURL=nl_NL.2dd7e637.js.map
